<template>
  <div class="white-card">
    <div class="p-lg-4" v-if="activeUser">
      <div class="safety-div">
        <div class="flex flex-wrap justify-around">
          <div
            class="w--half border border-1 border-teal-500 flex-col justify-center py-3 px-4">
            <p class="text-center font-19">Score d'assisuite</p>
            <div class="mt-3 smallHeight bg-gray-500 w-1/6 mx-auto"></div>
            <p class="leading-snug text-center font-300 text-5xl text-primary">
              <span class="font-black">{{ data.score }}</span> Points
            </p>
            <p class="text-sm mx-3 text-center">
              {{ activeUser.last_name }} est {{ data.rank }}e/{{ data.total }} dans sa salle de classe</p>
            <div class="flex justify-center mt-2 mb-6">
            </div>
          </div>
          <div class="w--half border border-1 border-teal-500 flex-col justify-center py-3 px-4">
            <p class="text-center font-19">Historique</p>
            <div class="my-2 smallHeight bg-gray-500 w-1/6 mx-auto"></div>
            <div class="text-sm text-center">
              <p class="leading">
                Derniere sceance:
                <span class="text-primary">{{ data.last_connexion || 'Jamais connécté' }}</span>
              </p>
              <p class="leading">
                Duree:
                <span class="text-primary">{{ (data.duration || 0) + ' minutes' }}</span>
              </p>
              <p class="leading">
                Nombre de sceances ce mois:
                <span class="text-primary">{{ data.month_connexions || 0 }}</span>
              </p>
              <p class="leading">
                Duree moyanne des sceances:
                <span class="text-primary">{{ (data.average_duration || 0) + ' minutes' }}</span>
              </p>
            </div>
            <div class="flex justify-center mt-2 mb-6">
              <!--              <button class="px-10 py-2 bg-teal-500 text-white text-sm">Voir plus de details</button>-->
            </div>
          </div>
          <div class="w--half mt-4 border border-1 border-teal-500 flex-col justify-center py-3 px-4">
            <p class="text-center font-19">Tableau de bord</p>
            <div class="my-2 smallHeight bg-gray-500 w-1/6 mx-auto"></div>
            <div class="text-sm text-center">
              <p class="leading">
                Vidéos consultées:
                <span class="text-primary">{{ data.video_count }}</span>
              </p>
              <p class="leading">
                Contenu consultés:
                <span class="text-primary">{{ data.content_count }}</span>
              </p>
            </div>
          </div>
          <div class="w--half mt-4 border border-1 border-teal-500 flex-col justify-center py-3 px-4">
            <p class="text-center font-19">Planning</p>
            <div class="my-2 smallHeight bg-gray-500 w-1/6 mx-auto"></div>
            <div class="text-sm text-center">
            <p class="leading">
              Conférences Participées:
              <span class="text-primary">{{ data.conference_done }}</span>
            </p>
            <p class="leading">
              Conférence manquées:
              <span class="text-primary">{{ data.conference_failed }}</span>
            </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p class="text-center" v-else>
      <router-link :to="{name:'profile',query: {section: 'student'}}" class="btn btn-outline-primary">
        Créer un compte élève
      </router-link>
    </p>
  </div>
</template>

<script>
import axios from 'axios'
import {mapGetters} from 'vuex'
import _ from 'lodash'

export default {
  name: 'Dashboard',
  data() {
    return {
      data: {}
    };
  },
  computed: {
    ...mapGetters(['children']),
    activeUser() {
      let index = _.findIndex(this.children, c => c.id == this.activeUserId)
      if (index === -1) index = 0
      return this.children[index]
    },
    activeUserId() {
      return this.$route.query.student
    }
  },
  methods: {
    loadData() {
      if (!this.activeUser) return
      axios.get('/dashboard/', {params: {student: this.activeUser.id}})
        .then(({data}) => {
          this.data = data
        })
    }
  },
  watch: {
    activeUser() {
      this.loadData()
    }
  },
  created() {
    this.loadData()
  }
};
</script>

<style>
</style>
